﻿

(function ($) {

	var quotes = $('.page-base__main__body').find('blockquote');

	quotes.each(function (i, ele) {

		var quote = $(ele);
		var cite = quote.attr('cite');

		if (cite !== undefined) {
			quote.append('<cite>' + cite + '</cite>');
		}
	});

})(jQuery);
